import React, { Component } from 'react';
import { Modal, Button, Input, Radio, Spin, Icon, message } from 'antd';
import ExportUtil from '../../../../common/ExportUtil';
import UploadFile from '../../../common/UploadFile';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';
import jquery from 'jquery';

const RadioGroup = Radio.Group;

class Attachment extends Component {
    state = {
        visible: false,
        loading: false,
        record: {},
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false }, () => {
            jquery('.tableC .transferCompany .ant-table-body').scrollTop(0);
        });
    }

    downLoadFile = (id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId: id }, null, url);
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 100,
        }, {
            title: '附件名称',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                const { id, name } = record;
                return <a onClick={() => this.downLoadFile(id)}>{name}</a>
            }
        }];
        return columns;
    }

    render() {
        const { visible, loading, record } = this.state;
        const { investigationJdeContractCode, fileList } = record;
        return (
            <Modal
                title="查看附件"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                confirmLoading={loading}
                width="600px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div style={{ position: 'relative', marginBottom: 10, paddingRight: 90, height: 28, lineHeight: '28px' }}>
                        JDE项目号：{investigationJdeContractCode}
                    </div>
                    <TableC
                        scrollY={220}
                        data={fileList}
                        columns={this.getColumns()}
                        onChange={this.handleTableChange}
                        className="attachment"
                        rowKey="id"
                    />
                </Spin>
            </Modal>
        );
    }
}

class ContractRequestFinish extends Component {
    state = {
        loading: false,
        visible: false,
        attachList: [],
        fileList: [],
        record: {},
        data: {},
        role: '',
    }

    show = (record, role) => {
        this.setState({
            role,
            record,
            visible: true,
        }, () => {
            this.loadAttachList();
            this.queryContractInfo();
        });
    }

    hide = () => {
        this.setState({
            data: {},
            fileList: [],
            attachList: [],
            visible: false,
        });
    }

    queryContractInfo = () => {
        const { record: { investigationJdeContractId, remittanceCompletedInfoShow } } = this.state;
        let url;
        if (remittanceCompletedInfoShow === '未确认' || remittanceCompletedInfoShow === 'PM拒绝确认' || remittanceCompletedInfoShow === 'FIN拒绝确认') {
            url = API_URL.contract.queryInvestigationJdeContractInfo;
        } else {
            url = API_URL.contract.queryInvestigationJdeContractCompletedApplyId;
        }
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url,
            data: {
                investigationJdeContractId,
                type:'jdeCloseOtherSupport',
            },
            dataType: 'json',
            doneResult: res => {
                const { data: { files, ...rest } } = res;
                const fileList = (files || []).map((item, index) => ({
                    fileMateId: item.fileMateId,
                    name: item.name,
                    response: { fileMetaId: item.fileMateId },
                    uid: index,
                }));
                this.setState({
                    fileList,
                    data: rest,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    loadAttachList = () => {
        const { record: { investigationJdeContractId } } = this.state;
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeCodeEnclosure,
            data: {
                investigationJdeContractId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ attachList: res.data });
            },
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { record: { investigationJdeContractId, remittanceCompletedInfoShow } } = this.state;
        const { role, data, fileList } = this.state;
        const { approvalStatus, reason, investigationJdeContractCompletedApplyId, files, ...rest } = data;

        let url, params;
        if (role === 'BA') {
            params = { ...rest };
            fileList.forEach((item, index) => {
                params[`ids[${index}]`] = item.response.fileMetaId;
            });
            url = API_URL.contract.addInvestigationJdeContractCompletedApply;
        } else {
            if (!approvalStatus) {
                message.warning('请确认合同请款是否完成！');
                return;
            } else if (approvalStatus === 'REJECT' && !reason) {
                message.warning('请填写拒绝原因！');
                return;
            }

            params = { investigationJdeContractCompletedApplyId };
            params.type = 'CONTRACT';
            params.approvalStatus = approvalStatus;
            params.reason = reason;
            
            if (remittanceCompletedInfoShow === '待PM确认') {
                url = API_URL.contract.pmExamineAndVerifyApply;
            } else {
                url = API_URL.contract.finExamineAndVerifyApply;
            }

            // if (role === 'PM' || role === 'CRC' || role === 'CRCC' || role === 'CRCM' || role === 'BO') {
            //     url = API_URL.contract.pmExamineAndVerifyApply;
            // } else {
            //     url = API_URL.contract.finExamineAndVerifyApply;
            // }
        }

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: params,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    handleInputChange = (e, key) => {
        const { data } = this.state;
        data[key] = e.target.value;
        if (key === 'approvalStatus') {
            data.reason = undefined;
        }
        this.setState({ data });
    }

    handleUploadChange = (file, fileList) => {
        this.setState({ fileList });
    }

    showAttachment = (record) => {
        this.attachmentRef.show(record);
    }

    getAttachment = (record) => {
        const { fileList } = record;
        return (fileList || []).length ? <Icon type="paper-clip" style={{margin: '0 10px', fontSize: '20px', color: '#ffbf00', cursor: 'pointer'}} onClick={() => this.showAttachment(record)}/> : null;
    }

    getContractAmount = () => {
        const { role, data } = this.state;
        const { 
            currency = '', 
            jdeContractAmount, 
            cashReqAmount, 
            contractBackAmount, 
            initialContractAmount,
            initialReqAmount, 
            initialBackAmount, 
            contracts, 
            grossAmount, 
            contraryInitialContractAmount,
            contraryJdeContractAmount, 
            canRequestAmount,
            initialCanRequestAmount, 
        } = data;
        const array = [];
        const isBA = role === 'BA';
        const currencyName = currency.slice(0, currency.indexOf('('));
        if (!isBA && currency === '人民币(CNY)') {
            array.push(
                <li className="modal-item" key="jdeContractAmount">
                    <div className="item-left">合同额含税/人民币:</div>
                    <div className="item-right">
                        {format('money', jdeContractAmount)} 元
                    </div>
                </li>,<li className="modal-item" key="contraryJdeContractAmount">
                    <div className="item-left">负值同额含税/人民币:</div>
                    <div className="item-right">
                        {format('money', contraryJdeContractAmount)} 元
                    </div>
                </li>,<li className="modal-item" key="canRequestAmount">
                    <div className="item-left">实际可请款金额含税/人民币:</div>
                    <div className="item-right">
                        {format('money', canRequestAmount)} 元
                    </div>
                </li>
            );
            let totalNegativeAmount = 0;
            if ((contracts || []).length) {
                contracts.forEach((item, index) => {
                    const { jdeContractAmount } = item;
                    totalNegativeAmount += jdeContractAmount;
                    array.push(
                        <li className="modal-item" key={index}>
                            <div className="item-left">{this.getAttachment(item)}合同额含税(负值合同):</div>
                            <div className="item-right">
                                {format('money', jdeContractAmount)} 元
                            </div>
                        </li>
                    );
                });
            }
            if (totalNegativeAmount) {
                array.push(
                    <li className="modal-item" key="jdeContractAmount1">
                        <div className="item-left">合同实际可请款金额/人民币:</div>
                        <div className="item-right">
                            {format('money', (jdeContractAmount + totalNegativeAmount))} 元
                        </div>
                    </li>
                );
            }
            array.push(
                <li className="modal-item" key="cashReqAmount">
                    <div className="item-left">已请款金额/人民币:</div>
                    <div className="item-right">
                        {format('money', cashReqAmount)} 元
                    </div>
                </li>,
                <li className="modal-item" key="grossAmount">
                    <div className="item-left">已开票金额/人民币:</div>
                    <div className="item-right">
                        {format('money', grossAmount)} 元
                    </div>
                </li>,
                <li className="modal-item" key="contractBackAmount">
                    <div className="item-left">已回款金额/人民币:</div>
                    <div className="item-right">
                        {format('money', contractBackAmount)} 元
                    </div>
                </li>
            );
        } else {
            const data = [
                {title: '合同额含税', initialAmount: format('money', initialContractAmount) , amount: format('money', jdeContractAmount)},
                {title: '负值合同额含税', initialAmount: format('money', contraryInitialContractAmount) , amount: format('money', contraryJdeContractAmount)},
                {title: '实际可请款金额含税', initialAmount: format('money', initialCanRequestAmount) , amount: format('money', canRequestAmount)},
            ];
            let totalNegativeAmount = 0;
            let totalInitialNegativeAmount = 0;
            if ((contracts || []).length) {
                contracts.forEach((item, index) => {
                    const { jdeContractAmount, initialContractAmount } = item;
                    totalNegativeAmount += jdeContractAmount;
                    totalInitialNegativeAmount += initialContractAmount;
                    data.push(
                        {title: <span>合同额含税(负值合同){this.getAttachment(item)}</span>, initialAmount: format('money', initialContractAmount), amount: format('money', jdeContractAmount)},
                    );
                });
            }
            if (totalNegativeAmount) {
                data.push(
                    {title: '合同实际可请款金额', initialAmount: format('money', (initialContractAmount + totalInitialNegativeAmount)), amount: format('money', (jdeContractAmount + totalNegativeAmount))}
                );
            }
            data.push(
                {title: '已请款金额', initialAmount: format('money', initialReqAmount), amount: format('money', cashReqAmount)},
                {title: '已开票金额', initialAmount: '-', amount: format('money', 
                grossAmount)},
                {title: '已回款金额', initialAmount: (!isBA && initialBackAmount) ? format('money', initialBackAmount) : '-', amount: format('money', contractBackAmount)},
            );
            const columns = [{
                title: '',
                dataIndex: 'title',
                key: 'title',
            }, {
                title: `原币/${currencyName}`,
                dataIndex: 'initialAmount',
                key: 'initialAmount',
            }, {
                title: '人民币/元',
                dataIndex: 'amount',
                key: 'amount',
            }];
            array.push(
                <TableC
                    data={data}
                    columns={columns}
                />
            );
        }
        return array;
    }

    getContent = () => {
        const {
            role,
            data,
            fileList,
            attachList,
        } = this.state;
        const {
            investigationName,
            investigationJdeContractMainCode,
            investigationJdeContractCode,
            currency,
            exchangeRate,
            comments,
            approvalStatus,
            reason,
        } = data;

        const uploadParams = {
            uploadType: 'CONTRACT_COMPLETE_APPLY',
            path: Date.now(),
            relateId: '',
        };
        const asterisk = <span style={{color: 'red'}}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">项目简称:</div>
                    <div className="item-right">
                        {investigationName}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">JDE主项目号:</div>
                    <div className="item-right">
                        {investigationJdeContractMainCode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">JDE项目号:</div>
                    <div className="item-right">
                        {investigationJdeContractCode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">合同附件:</div>
                    <div className="item-right">
                        {
                            attachList.map(item => <a key={item.id} onClick={e => this.downLoadFile(e, item.id)}>{item.name}<br/></a>)
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">币种:</div>
                    <div className="item-right">
                        {currency}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">汇率:</div>
                    <div className="item-right">
                        {exchangeRate}
                    </div>
                </li>
                { this.getContractAmount() }
                <li className="modal-item">
                    <div className="item-left">备注:</div>
                    <div className="item-right">
                        {
                            role === 'BA' ?
                                <Input
                                    maxLength="255"
                                    value={comments}
                                    placeholder="请输入"
                                    style={{width: 300}}
                                    onChange={e => this.handleInputChange(e, 'comments')}
                                />
                            :
                                comments
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">其他支持性文件:</div>
                    <div className="item-right">
                        {
                            role === 'BA' ?
                                <UploadFile
                                    data={uploadParams}
                                    fileList={fileList}
                                    uploadUrl={API_URL.proContract.uploadJdeCodeEnclosure}
                                    removeUrl={API_URL.proContract.deleteJdeCodeEnclosure}
                                    onChange={this.handleUploadChange}
                                >
                                    <div>
                                        <Button style={{width: 80}}>选择文件</Button>
                                        <p style={{color: '#ffa500'}}>请上传和客户确认最终结算金额的邮件或其他支持性文件以备查看</p>
                                    </div>
                                </UploadFile>
                            :
                                fileList.map(i => <a key={i.fileMateId} onClick={e => this.downLoadFile(e, i.fileMateId)}>{i.name}<br/></a>)
                        }
                    </div>
                </li>
                {
                    role !== 'BA' &&
                    <li className="modal-item" style={{ borderTop: '1px solid #f1f1f1' }}>
                        <div className="item-left">{asterisk}{role=='FIN'?'FIN':'PM'}是否确认合同请款完成:</div>
                        <div className="item-right">
                            <RadioGroup onChange={e => this.handleInputChange(e, 'approvalStatus')} value={approvalStatus}>
                                <Radio value='AGREE'>确认</Radio>
                                <Radio value='REJECT'>拒绝</Radio>
                            </RadioGroup>
                        </div>
                    </li>
                }
                {
                    role !== 'BA' && approvalStatus === 'REJECT' &&
                    <li className="modal-item">
                        <div className="item-left">{asterisk}拒绝原因:</div>
                        <div className="item-right">
                            <Input
                                maxLength="255"
                                value={reason}
                                placeholder="请填写拒绝原因"
                                style={{width: 300}}
                                onChange={e => this.handleInputChange(e, 'reason')}
                            />
                        </div>
                    </li>
                }
            </ul>
        );
    }

    render() {
        const { visible, loading, role } = this.state;
        return (
            <Modal
                title={role === 'BA' ? '合同确认请款完成申请' : '确认合同请款完成'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <Spin spinning={loading}>
                        { this.getContent() }
                    </Spin>
                    <Attachment ref={el => this.attachmentRef = el} />
                </div>
            </Modal>
        ); 
    }
}

export default ContractRequestFinish;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/ContractRequestFinish.js